_ = require('lodash')

hdcpToLabel = (HdcpService) ->
  (input) ->
    hdcpObj = HdcpService.getHdcpObject input
    if hdcpObj.integer == null or hdcpObj.float == null
      '_'
    else
      # display text is not negative number as its value in databes, change it: -1 => +1 and 1 => 1
      (if input < 0 then '+' else '') + Math.abs(hdcpObj.integer) + hdcpObj.float

hdcpToLabel.$inject = [
  'HdcpService'
]

module.exports = hdcpToLabel



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/hdcp/hdcp-to-label-filter.coffee